import { oz } from '@weft/utils';
import { NetSuiteInvoiceSchema } from './net-suite-invoice-schema';
import { NetSuiteSalesOrderItemSchema } from './net-suite-sales-order-item-schema';

export const NetSuiteSalesOrderSchema = NetSuiteInvoiceSchema.extend({
  subsidiary: oz.object({
    id: oz.string(),
  }),
  item: oz.object({
    items: oz.array(NetSuiteSalesOrderItemSchema),
  }),
}).openapi('NetSuiteSalesOrder');

export type NetSuiteSalesOrder = oz.infer<typeof NetSuiteSalesOrderSchema>;